import { render, staticRenderFns } from "./coupon-index.vue?vue&type=template&id=255c968a"
import script from "./coupon-index.vue?vue&type=script&lang=js"
export * from "./coupon-index.vue?vue&type=script&lang=js"
import style0 from "./coupon-index.vue?vue&type=style&index=0&id=255c968a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports